import React, { useState } from 'react';
import { CATS, TC } from '../data/constants';

export function InstitutionProfileModal({ theme, instProfileId, setInstProfileId, setDetailId, places }) {
  const C = (k) => {
    const d = theme === 'dark';
    const m = {
      surf:d?'#141924':'#FFFAF5',
      surf2:d?'rgba(255,255,255,0.03)':'rgba(139,92,246,0.04)',
      bord:d?'rgba(255,255,255,0.07)':'rgba(139,92,246,0.10)',
      txt:d?'#ffffff':'#1E1048',
      txt2:d?'rgba(255,255,255,0.5)':'#4B3D7A',
      txt3:d?'rgba(255,255,255,0.25)':'#9B8FBD',
    };
    return m[k]||'';
  };
  const [activeTab, setActiveTab] = useState('genel');
  if (!instProfileId) return null;
  const p = places.find(function(x){return String(x.id) === String(instProfileId);});
  if (!p) return null;
  const color = p.sponsored ? '#FFD700' : TC[p.type];
  const cat = CATS.find(function(c){return c.id === p.type;}) || {};
  const fillPct = Math.round((p.capacity > 0 ? p.filled/p.capacity : 0)*100);
  const fillColor = fillPct>80?'#FF6B6B':fillPct>60?'#FFE66D':'#4ECDC4';

  const TABS = [
    {id:'genel',      label:'Genel'},
    {id:'istatistik', label:'İstatistikler'},
    {id:'okulbot',    label:'OkulBot'},
  ];

  const StatCard = function({icon,val,label,col}){return(
    <div style={{background:C('surf2'),borderRadius:12,padding:14,border:'1px solid '+C('bord'),textAlign:'center'}}>
      <div style={{fontSize:22,marginBottom:4}}>{icon}</div>
      <div style={{color:col||C('txt'),fontSize:20,fontWeight:800,fontFamily:'Syne,sans-serif',lineHeight:1}}>{val}</div>
      <div style={{color:C('txt2'),fontSize:11,marginTop:4}}>{label}</div>
    </div>
  );};

  return (
    <div style={{position:'fixed',inset:0,zIndex:900,display:'flex',alignItems:'center',justifyContent:'center',background:'rgba(0,0,0,0.75)',backdropFilter:'blur(8px)'}}
      onClick={function(){setInstProfileId(null);}}>
      <div style={{background:C('surf'),borderRadius:20,width:500,maxHeight:'90vh',display:'flex',flexDirection:'column',animation:'fadeIn 0.2s ease',boxShadow:'0 24px 64px rgba(0,0,0,0.5)',overflow:'hidden'}}
        onClick={function(e){e.stopPropagation();}}>

        {/* Header */}
        <div style={{background:'linear-gradient(135deg,'+color+'25,'+C('surf')+')',padding:'18px 18px 16px',borderBottom:'1px solid '+C('bord'),flexShrink:0}}>
          <div style={{display:'flex',alignItems:'center',gap:10,marginBottom:14}}>
            <button onClick={function(){setInstProfileId(null); setDetailId(p.id);}}
              style={{width:32,height:32,borderRadius:9,background:'rgba(0,0,0,0.3)',border:'1px solid rgba(255,255,255,0.1)',color:'#fff',fontSize:15,cursor:'pointer',display:'flex',alignItems:'center',justifyContent:'center',flexShrink:0}}>←</button>
            <span style={{color:C('txt2'),fontSize:12}}>Kurum Paneli</span>
            {p.okulbot && <span style={{marginLeft:'auto',background:'rgba(168,218,255,0.15)',border:'1px solid rgba(168,218,255,0.3)',borderRadius:6,padding:'2px 7px',fontSize:10,color:'#A8DAFF',fontWeight:700}}>✦ OkulBot</span>}
          </div>
          <div style={{display:'flex',gap:14,alignItems:'center'}}>
            <div style={{width:60,height:60,borderRadius:16,background:color+'20',border:'2px solid '+color+'50',display:'flex',alignItems:'center',justifyContent:'center',fontSize:28,flexShrink:0}}>
              {cat.icon||p.photos[0]}
            </div>
            <div style={{flex:1,minWidth:0}}>
              <div style={{display:'flex',alignItems:'center',gap:8,marginBottom:4}}>
                <div style={{fontSize:17,fontWeight:800,color:C('txt'),fontFamily:'Syne,sans-serif',whiteSpace:'nowrap',overflow:'hidden',textOverflow:'ellipsis'}}>{p.name}</div>
              </div>
              <div style={{color:color,fontSize:12,fontWeight:600,marginBottom:3}}>{cat.label}</div>
              <div style={{display:'flex',gap:8}}>
                <span style={{color:C('txt2'),fontSize:11}}>★ {p.rating}</span>
                <span style={{color:C('txt3')}}>·</span>
                <span style={{color:C('txt2'),fontSize:11}}>{p.reviews} yorum</span>
                <span style={{color:C('txt3')}}>·</span>
                <span style={{color:p.open?'#4ECDC4':'#888',fontSize:11}}>{p.open?'Açık':'Kapalı'}</span>
              </div>
            </div>
          </div>
        </div>

        {/* Tabs */}
        <div style={{display:'flex',borderBottom:'1px solid '+C('bord'),flexShrink:0}}>
          {TABS.map(function(t){return(
            <button key={t.id} onClick={function(){setActiveTab(t.id);}}
              style={{flex:1,padding:'13px 0',background:'none',border:'none',borderBottom:'2px solid '+(activeTab===t.id?color:'transparent'),color:activeTab===t.id?color:C('txt2'),fontSize:13,fontWeight:activeTab===t.id?700:400,cursor:'pointer',fontFamily:'DM Sans,sans-serif',transition:'all 0.2s'}}>
              {t.label}
            </button>
          );})}
        </div>

        {/* Content */}
        <div style={{flex:1,overflowY:'auto',padding:16}}>

          {/* ── GENEL ── */}
          {activeTab==='genel' && (
            <>
              <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:10,marginBottom:16}}>
                <StatCard icon="👶" val={p.age}    label="Yaş Grubu"        col="#A8DAFF"/>
                <StatCard icon="🕐" val={p.hours}  label="Çalışma Saatleri" col="#4ECDC4"/>
                <StatCard icon="💰" val={p.price}  label="Aidat"            col={color}/>
                <StatCard icon="🏛" val={String(p.capacity)} label="Kapasite" col="#FFE66D"/>
                {p.avgClassSize && <StatCard icon="👥" val={p.avgClassSize+' kişi'} label="Sınıf Mevcudu" col="#A8DAFF"/>}
                {p.teacherChildRatio && <StatCard icon="👥" val={p.teacherChildRatio} label="Öğretmen/Çocuk" col="#4ECDC4"/>}
              </div>

              <div style={{background:C('surf2'),borderRadius:12,padding:14,border:'1px solid '+C('bord'),marginBottom:16}}>
                <div style={{display:'flex',justifyContent:'space-between',marginBottom:8}}>
                  <span style={{color:C('txt2'),fontSize:13,fontWeight:600}}>Doluluk</span>
                  <span style={{color:fillColor,fontSize:13,fontWeight:700}}>{p.open?p.filled+'/'+p.capacity+' kişi (%'+fillPct+')':'Kapalı'}</span>
                </div>
                <div style={{height:8,background:'rgba(255,255,255,0.06)',borderRadius:4,overflow:'hidden'}}>
                  <div style={{height:'100%',width:(p.open?fillPct:0)+'%',background:fillColor,borderRadius:4,transition:'width 0.8s'}}/>
                </div>
                {fillPct>85 && <div style={{color:'#FF6B6B',fontSize:11,marginTop:6}}>⚠ Kontenjan dolmak üzere — hızlı kayıt önerilir</div>}
              </div>

              {p.features.length>0 && (
                <div style={{marginBottom:16}}>
                  <div style={{color:C('txt3'),fontSize:11,fontWeight:600,letterSpacing:'0.08em',marginBottom:8}}>ÖZELLİKLER</div>
                  <div style={{display:'flex',flexWrap:'wrap',gap:6}}>
                    {p.features.map(function(f){return <span key={f} style={{background:color+'15',border:'1px solid '+color+'30',borderRadius:8,padding:'5px 10px',fontSize:11,color:color,fontWeight:500}}>{f}</span>;})}
                  </div>
                </div>
              )}

              <p style={{color:C('txt2'),fontSize:13,lineHeight:1.7,marginBottom:16}}>{p.desc}</p>

              <div style={{background:C('surf2'),borderRadius:12,border:'1px solid '+C('bord'),overflow:'hidden'}}>
                {[{icon:'📞',label:'Telefon',val:'—'},{icon:'📍',label:'Adres',val:'Kadıköy / İstanbul'},{icon:'🌐',label:'Web',val:'okulmap.com'}].map(function(r,i,a){return(
                  <div key={i} style={{display:'flex',alignItems:'center',gap:12,padding:'12px 14px',borderBottom:i<a.length-1?'1px solid '+C('bord'):'none'}}>
                    <span style={{fontSize:16}}>{r.icon}</span>
                    <div>
                      <div style={{color:C('txt3'),fontSize:10,marginBottom:1}}>{r.label}</div>
                      <div style={{color:C('txt'),fontSize:12}}>{r.val}</div>
                    </div>
                  </div>
                );})}
              </div>
            </>
          )}

          {/* ── İSTATİSTİKLER ── */}
          {activeTab==='istatistik' && (
            <>
              <div style={{color:C('txt3'),fontSize:11,fontWeight:600,letterSpacing:'0.08em',marginBottom:12}}>BU AY</div>
              <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:10,marginBottom:20}}>
                <StatCard icon="👁"  val="1.240" label="Profil Görüntüleme" col="#A8DAFF"/>
                <StatCard icon="❤️" val="87"    label="Favoriye Ekleme"    col="#FF6B6B"/>
                <StatCard icon="📅" val="23"    label="Ziyaret Talebi"     col="#4ECDC4"/>
                <StatCard icon="📞" val="41"    label="Arama"              col="#FFE66D"/>
              </div>

              <div style={{color:C('txt3'),fontSize:11,fontWeight:600,letterSpacing:'0.08em',marginBottom:12}}>PUAN DAĞILIMI</div>
              <div style={{background:C('surf2'),borderRadius:12,padding:14,border:'1px solid '+C('bord'),marginBottom:20}}>
                {[{s:5,pct:72},{s:4,pct:18},{s:3,pct:7},{s:2,pct:2},{s:1,pct:1}].map(function(r){return(
                  <div key={r.s} style={{display:'flex',alignItems:'center',gap:8,marginBottom:8}}>
                    <span style={{color:'#FFE66D',fontSize:12,width:16}}>★{r.s}</span>
                    <div style={{flex:1,height:6,background:'rgba(255,255,255,0.06)',borderRadius:3,overflow:'hidden'}}>
                      <div style={{height:'100%',width:r.pct+'%',background:'linear-gradient(90deg,#FFE66D,#FFA500)',borderRadius:3}}/>
                    </div>
                    <span style={{color:C('txt2'),fontSize:11,width:28,textAlign:'right'}}>{r.pct}%</span>
                  </div>
                );})}
              </div>

              <div style={{color:C('txt3'),fontSize:11,fontWeight:600,letterSpacing:'0.08em',marginBottom:12}}>HARİTA ÜZERİNDEKİ KONUM</div>
              <div style={{background:C('surf2'),borderRadius:12,padding:14,border:'1px solid '+C('bord'),display:'flex',alignItems:'center',gap:12}}>
                {p.sponsored
                  ? <><span style={{fontSize:24}}>★</span><div><div style={{color:'#FFD700',fontSize:13,fontWeight:700}}>Sponsorlu Pin Aktif</div><div style={{color:C('txt2'),fontSize:11,marginTop:2}}>Arama sonuçlarında öne çıkıyorsunuz</div></div></>
                  : <><span style={{fontSize:24}}>📍</span><div><div style={{color:C('txt'),fontSize:13,fontWeight:600}}>Standart Konum</div><div style={{color:C('txt2'),fontSize:11,marginTop:2}}>Sponsorlu pin ile öne çıkabilirsiniz</div></div></>
                }
              </div>
            </>
          )}

          {/* ── OKULBOT ── */}
          {activeTab==='okulbot' && (
            <>
              {p.okulbot ? (
                <>
                  <div style={{background:'linear-gradient(135deg,rgba(168,218,255,0.1),rgba(78,205,196,0.06))',border:'1px solid rgba(168,218,255,0.25)',borderRadius:14,padding:20,marginBottom:16,textAlign:'center'}}>
                    <img src="/logo.png?v=3" alt="OkulBot" style={{height:52,objectFit:'contain',marginBottom:12}}/>
                    <div style={{color:'#A8DAFF',fontSize:15,fontWeight:700,marginBottom:6}}>OkulBot Aktif</div>
                    <div style={{color:C('txt2'),fontSize:13,lineHeight:1.6}}>Bu kurum OkulBot ile dijital olarak yönetilmektedir.</div>
                  </div>
                  {['Devamsızlık takibi','Veli bildirimleri','Ödeme yönetimi','okulmap.com entegrasyonu'].map(function(f,i){return(
                    <div key={i} style={{display:'flex',alignItems:'center',gap:10,padding:'10px 0',borderBottom:'1px solid '+C('bord')}}>
                      <span style={{color:'#4ECDC4',fontSize:14}}>✓</span>
                      <span style={{color:C('txt'),fontSize:13}}>{f}</span>
                    </div>
                  );})}
                  <button onClick={function(){window.open(p.okulbot,'_blank');}}
                    style={{width:'100%',padding:14,borderRadius:12,background:'linear-gradient(135deg,#A8DAFF,#7BB8F0)',border:'none',color:'#000',fontSize:13,fontWeight:700,cursor:'pointer',fontFamily:'DM Sans,sans-serif',marginTop:16,boxShadow:'0 4px 20px rgba(168,218,255,0.3)'}}>
                    OkulBot Paneline Git →
                  </button>
                </>
              ) : (
                <>
                  <div style={{textAlign:'center',marginBottom:20}}>
                    <img src="/logo.png?v=3" alt="OkulBot" style={{height:52,objectFit:'contain',marginBottom:10}}/>
                    <div style={{color:C('txt'),fontSize:15,fontWeight:700,marginBottom:6}}>OkulBot'u Keşfedin</div>
                    <div style={{color:C('txt2'),fontSize:13,lineHeight:1.6}}>Kurumunuzu dijital ortamda yönetin, velilerle kolayca iletişim kurun.</div>
                  </div>
                  {[{icon:'📱',title:'WhatsApp bildirimleri',desc:'Velilere anlık mesaj gönderin'},{icon:'📊',title:'Devamsızlık takibi',desc:'Dijital yoklama ve raporlar'},{icon:'💳',title:'Ödeme yönetimi',desc:'Fatura ve tahsilat takibi'},{icon:'⭐',title:'Sponsorlu pin',desc:"okulmap.com'te öne çıkın"}].map(function(f,i){return(
                    <div key={i} style={{display:'flex',gap:12,padding:'12px 0',borderBottom:'1px solid '+C('bord')}}>
                      <span style={{fontSize:20,width:28,textAlign:'center'}}>{f.icon}</span>
                      <div>
                        <div style={{color:C('txt'),fontSize:13,fontWeight:600}}>{f.title}</div>
                        <div style={{color:C('txt2'),fontSize:12}}>{f.desc}</div>
                      </div>
                    </div>
                  );})}
                  <button style={{width:'100%',padding:14,borderRadius:12,background:'linear-gradient(135deg,#A8DAFF,#7BB8F0)',border:'none',color:'#000',fontSize:13,fontWeight:700,cursor:'pointer',fontFamily:'DM Sans,sans-serif',marginTop:16,boxShadow:'0 4px 20px rgba(168,218,255,0.3)'}}>
                    OkulBot'u Ücretsiz Dene →
                  </button>
                </>
              )}
            </>
          )}
        </div>
      </div>
    </div>
  );
}
